const _             = require('underscore');
const status        = require('../util/status');
const offline_modal = require('../modals/offline_modal');

function guard(handler) {
  return _.wrap(handler, f => {
    return status.onLine ? f() : offline_modal.open();
  });
}

function wait(handler) {
  if (status.onLine) return handler();
  status.one('online', () => handler());
}

module.exports = { guard, wait };
